import { ORDER_CONFIG } from "./customStatus/OrdersStatus.config";
import { PAYMENT_CONFIG } from "./customStatus/PaymentStatus.config";
import { APPROVAL_CONFIG } from "./customStatus/ApprovalStatus.config";
import { ATTENDANCE_CONFIG } from "./customStatus/AttendanceStatus.config";
import { USER_ACCOUNT_CONFIG } from "./customStatus/UserAccountStatus.config";
import { SYSTEM_HEALTH_CONFIG } from "./customStatus/SystemHealthStatus.config";
import { DELIVERY_SHIPPING_CONFIG } from './customStatus/DeliveryShippingStatus.config';
import { PROFILE_STATUS_CONFIG } from './customStatus/ProfileStatus.config';
import { ELIGIBILITY_CONFIG } from "./customStatus/EligibleStatus.config";
import { ANNOUNCEMENT_STATUS_CONFIG } from "./customStatus/AnnouncementStatus.config";

export const STATUS_CONFIG = {
    // Attendance
    ...ATTENDANCE_CONFIG,

    //  Order / Task
    ...ORDER_CONFIG,

    // Payment
    ...PAYMENT_CONFIG,

    // User / Account 
    ...USER_ACCOUNT_CONFIG,

    // Approval 
    ...APPROVAL_CONFIG,

    // Delivery / Shipping
    ...DELIVERY_SHIPPING_CONFIG,

    // System / Health
    ...SYSTEM_HEALTH_CONFIG,
    ...PROFILE_STATUS_CONFIG,

    ...ELIGIBILITY_CONFIG,
    ...ANNOUNCEMENT_STATUS_CONFIG
};

export const STATUS_VARIANT = {
    BADGE: "badge",
    CHIP: "chip",
    DOT: "dot"
};

export const STATUS_SIZE = {
    XS: "xs",
    SM: "sm",
    MD: "md",
    LG: "lg",
    XL: "xl",
    XXL: "xxl",
    XXXL: "xxxl",
};
